import React from 'react'
import {withNav} from '../../../core/components/navbar/index'
//import ProfileHeader from './ProfileHeader'
import VisibleProfileHeader from '../containers/VisibleProfileHeader'
//import ProfileFeed from './ProfileFeed'

let Profile = ({className, children}) => {
  return (
    <div className={className ? className : ''}>
      <VisibleProfileHeader />
      {children}
    </div>
  )
}
Profile = withNav(Profile, true)
export default Profile



// WEBPACK FOOTER //
// ./src/domains/user/components/Profile.js